// extracted by mini-css-extract-plugin
export default {"blur-on-hover":"Carousel_blur-on-hover__WdeSE","image-container":"Carousel_image-container__i09dB","play-button":"Carousel_play-button__Po29r"};